export const LANG_RU = 'ru';
export const LANG_UZ = 'uz';
export const LANG_OZ = 'oz';
export const LANG_EN = 'en';

export const LANG_LIST = [LANG_RU, LANG_UZ, LANG_OZ, LANG_EN];

export const LANG_DICTIONARY: Record<string, Record<string, string>> = {
  [LANG_RU]: { label: 'Русский', labelCode: 'Ру' },
  [LANG_UZ]: { label: 'Ўзбекча', labelCode: 'Ўз' },
  [LANG_OZ]: { label: 'O‘zbekcha', labelCode: 'O‘z' },
  // [LANG_EN]: { label: 'English', labelCode: 'En' },
};

export const QUESTION_LANGUAGES = [
  { code: LANG_RU, label: 'Русский' },
  { code: LANG_UZ, label: 'Ўзбекча' },
];
